import type { LeftoverChoice, LeavingSettlement } from "@shared/staff-settlement";

/** Leaving-only UI gate. The server independently validates eligible people and amounts. */
export function settlementChoicesComplete(s: LeavingSettlement, choices: LeftoverChoice[]) {
  return s.leftovers.filter(l => l.requiresChoice).every(item => {
    const matches = choices.filter(c => c.itemType === item.itemType && c.itemId === item.itemId);
    if (matches.length !== 1) return false;
    const c = matches[0];
    if (!c.reason.trim()) return false;
    if (c.responsibilityType === "branch_loss") return c.userIds.length === 0;
    if (c.responsibilityType === "employee") return c.userIds.length <= 1;
    return ["branch_manager", "recorder", "other"].includes(c.responsibilityType) && c.userIds.length === 1;
  });
}
